<template>
  <div class="editor-play-content">
    <div id="svg-path-calc-preview"></div>
    <div id="editor-scene-mask"></div>
    <div class="subtitle-player">
      <Subtitle
        v-for="(subtitle, k) in subtitles"
        :key="k"
        :subtitle="subtitle"
      />
    </div>
    <div v-if="watermarkShown" class="water-mark" :class="['water-mark', this.optimized !== 'Horizontal' && 'water-mark-v']"></div>
    <div v-show="optimized!=='Horizontal'" class="Vertical-mask" style="left:0"></div>
    <div v-show="optimized!=='Horizontal'" class="Vertical-mask" style="right:0"></div>
    <EditorPlayScene
      v-for="(scene,k) in scenes"
      :key="k"
      :scene="scene"
      @loadDone="loadDone"
    />
    <div
      v-show="!loaded"
      class="editor-loading"
    >
      <i></i>
      <span>{{`草稿正在快速加载中（${loadPer}%）`}}</span>
    </div>
  </div>
</template>
<script>
import AnimEditor from './editor';
import { mapMutations, mapGetters } from 'vuex';
import EditorPlayScene from './editorPlayScene'
import Subtitle from './subtitle.vue'
// import fetch_data from './fetch_data'

export default {
  name: 'EditorPlay',
  components: {
    EditorPlayScene,
    Subtitle
  },
  data(){
    return{
      isPlay: false,
      optimized: 'Horizontal',
      scenes: [],
      subtitles: [],
      scenesEffect: null,
      playFrame: null,
      loadNum: 0,
      loaded: false,
      loadLength: 0,
      autoplay: true,
      editor: null,
      loadPer: 0,
      draftDirection: ''
    };
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'UserLevelInfo'
    ]),
    ...mapGetters({
      draftBeforeRender: 'previewControls/draftBeforeRender',
      subtitleObj: 'subtitle/subtitleObj'
    }),
    watermarkShown () {
      return this.UserLevelInfo.levelName === 'basic' || this.UserLevelInfo.trial;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initEditor();
    });

    window.addEventListener('resize', this.setSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setSize);
  },
  methods: {
    ...mapMutations({
      setEditor: 'previewTool/setEditor',
      initInfo: 'previewInit/initInfo',
      setNoData: 'previewInit/setNoData',
      setTitle: 'previewInit/setTitle',
      setOptimized: 'previewTool/setOptimized',
      setLoaded: 'previewTool/setLoaded'
    }),
    async initEditor() {
      this.setLoaded(false);
      // let data = await fetch_data(window.location.href);
      // if(!data) {
      //   this.setNoData(true)
      //   return;
      // }
      // this.initInfo(data);
      // let editor = JSON.parse(data.data);
      let editor = this.TOOL.toJson();
      editor.scenes.forEach((v => {
        v.sprites.forEach(x => {
          if (x.type === 'Video' && /\.webm$/i.test(x.url)) {
            x.type = 'Gif';
            x.url = x.url.replace(/\.webm$/i, '_web.apng');
          }
        });
      }));
      editor.subtitle = this.subtitleObj;
      // if(!data.title) {
      //   this.setTitle('草稿预览');
      // }
      this.setOptimized(editor.optimized);
      this.draftDirection = editor.optimized;
      this.setSize();
      let _editor = new AnimEditor(editor.id, {frameRate: 30});
      await _editor.fromJson(editor);
      this.loadLength = _editor.loadLength;
      // 方便开发使用
      window._preview = _editor;
      this.editor = _editor;
      this.optimized = _editor.optimized;
      this.setEditor(_editor);
      // _editor.updateScenesPlayData();
      this.scenes = _editor.scenes;
      this.scenesEffect = _editor.scenesEffect;
      this.subtitles = _editor.subtitles.subtitles;

      // this.setSize();
    },
    loadDone() {
      this.loadNum++;
      this.loadPer = Math.floor(this.loadNum / this.loadLength * 100) ;

      if(this.loadNum >= this.loadLength) {
        this.loaded = true;
        // 加载完毕后默认显示第一个场景页
        this.scenes[0].show = true;
        this.editor.updateScenesPlayData()
        this.editor.play({isPlay: false, time: 0})
        this.setLoaded(true);
      }
    },
    setSize() {
      const editorRatio = 16 / 9;
      const isDraftVertical = this.draftDirection === 'Vertical';
      const ratio = isDraftVertical ? 9 / 16 : 16 / 9;
      const outerW = document.body.offsetWidth;
      const outerH = document.body.offsetHeight;
      const sameHeight = outerW / outerH > ratio;
      let shownW = outerW;
      if (sameHeight) {
        shownW = outerH * ratio;
      }
      let width = shownW;
      if (isDraftVertical) {
        width = shownW / ratio / ratio;
      }
      const height = width / editorRatio;
      let left = (outerW - width) / 2;
      let top = (outerH - height) / 2;
      this.$store.commit('previewInit/setSize', {width, left, top});
    }
  }
};
</script>
<style lang="scss" scoped>
.editor-play-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
  perspective: 600px;
  transform-origin: 0 0;
  overflow: hidden;
}
#editor-scene-mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  overflow: hidden;
  width: 1920px;
  height: 1080px;
}
.subtitle-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
  z-index: 19999;
  overflow: hidden;
}
.water-mark {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
  z-index: 29999;
  background: url(../../../static/animengine/img/icon-default-watermark-h.png) 50% 50% / 100% 100% no-repeat;
}
.water-mark-v {
  width: 607.5px;
  left: 656.25px;
  background: url(../../../static/animengine/img/icon-default-watermark-v.png) 50% 50% / 100% 100% no-repeat;
}
.editor-loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .6);

  i {
    width: 80px;
    height: 80px;
    background: url(./images/loading.svg) no-repeat center;
    background-size: 80px 80px;
    transform-origin: center;
    animation: 3s linear 0s infinite running loading-rotate;
  }

  span {
    margin-top: 32px;
    color: #fff;
    font-size: 45px;
    font-weight: bold;
  }
}
@keyframes loading-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
<style lang="scss">
#svg-path-calc {
  visibility: hidden;
}
.frame-mask {
  position: absolute;
  top: 0;
  left: 0;
}

.frame-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.frame-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.video-sprite-video{
  width: 100%;
  height: 100%;
}
.sprite-border {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  box-sizing: border-box;
}
.Vertical-mask{
  width: 656.25px;
  height: 1080px;
  position: absolute;
  top: 0;
  background-color: #666;
  z-index: 100000;
}
</style>



// WEBPACK FOOTER //
// src/components/draftPreview/editorPlay.vue